"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamoDbSortKey = void 0;
var DynamoDbSortKey;
(function (DynamoDbSortKey) {
    DynamoDbSortKey["ID"] = "ID";
})(DynamoDbSortKey = exports.DynamoDbSortKey || (exports.DynamoDbSortKey = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHluYW1vZGItc29ydC1rZXktZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vZW51bXMvZHluYW1vZGItc29ydC1rZXktZW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFFSCxJQUFZLGVBRVg7QUFGRCxXQUFZLGVBQWU7SUFDekIsNEJBQVMsQ0FBQTtBQUNYLENBQUMsRUFGVyxlQUFlLEdBQWYsdUJBQWUsS0FBZix1QkFBZSxRQUUxQiJ9